module.exports = __webpack_public_path__ + "5e47fb6a6411a5335e80305bff84638b.pdf";